import { Routes } from '@angular/router';
import { documentsResolver } from '../features/documents/documents.resolver';

/**
 * Document feature routes with lazy loading
 * All routes are protected by MsalGuard and the shared route guards at the feature level
 */
export const documentsRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('../features/documents/documents.component').then((m) => m.DocumentsComponent),
    resolve: {
      documents: documentsResolver
    }
  },
];
